import Head from 'next/head'
import { sanitize } from '#/utils/sanitize'

interface MetaProps {
  meta: Blog.Meta
}

const Meta: React.FC<MetaProps> = ({ meta }) => (
  <Head>
    <link
      href='/favicon/apple-touch-icon.png'
      rel='apple-touch-icon'
      sizes='180x180'
    />
    <link
      href='/favicon/favicon-32x32.png'
      rel='icon'
      sizes='32x32'
      type='image/png'
    />
    <link
      href='/favicon/favicon-16x16.png'
      rel='icon'
      sizes='16x16'
      type='image/png'
    />
    <link href='/favicon/site.webmanifest' rel='manifest' />
    <link
      color='#000000'
      href='/favicon/safari-pinned-tab.svg'
      rel='mask-icon'
    />
    <link href='/favicon/favicon.ico' rel='icon' />
    {meta?.site_name ? (
      <meta
        key='og:site_name'
        content={meta?.site_name}
        property='og:site_name'
      />
    ) : null}
    <meta content='#000000' name='msapplication-TileColor' />
    <meta content='/favicon/browserconfig.xml' name='msapplication-config' />
    <meta content='#000' name='theme-color' />
    <link href='/feed.xml' rel='alternate' type='application/rss+xml' />
    <meta
      key='twitter:creator'
      content='@tophap_inc'
      name='twitter:creator'
    />
    {meta?.image ? (
      <meta key='thumbnail' content={meta?.image} name='thumbnail' />
    ) : null}

    <meta
      key='twitter:card'
      content='summary_large_image'
      name='twitter:card'
    />

    <meta key='twitter:site' content='@tophap_inc' name='twitter:site' />
    {meta?.title ? (
      <meta key='twitter:title' content={meta?.title} name='twitter:title' />
    ) : null}
    {meta?.title ? (
      <meta key='og:title' content={meta?.title} name='og:title' />
    ) : null}
    {meta?.openGraph?.opengraphDescription ? (
      <>
        <meta
          key='description'
          content={meta?.openGraph.opengraphDescription}
          name='description'
          property='description'
        />
        <meta
          key='og:description'
          content={meta?.openGraph.opengraphDescription}
          name='og:description'
          property='og:description'
        />
        <meta
          key='twitter:description'
          content={meta?.openGraph.opengraphDescription}
          name='twitter:description'
        />
      </>
    ) : null}
    {meta?.openGraph?.opengraphTitle ? (
      <title>{meta?.openGraph?.opengraphTitle}</title>
    ) : null}
    {meta?.image ? (
      <>
        <meta key='og:image' content={meta?.image} name='og:image' />
        <meta
          key='twitter:image'
          content={meta?.image}
          name='twitter:image'
        />
        <meta key='og:image:width' content='1200' property='og:image:width' />
        <meta
          key="og:image:height'"
          content='630'
          property='og:image:height'
        />
        <meta
          key='twitter:image:width'
          content='1200'
          property='twitter:image:width'
        />
        <meta
          key='twitter:image:height'
          content='630'
          property='twitter:image:height'
        />
      </>
    ) : null}
    {meta?.title ? (
      <>
        <meta
          key='twitter:title'
          content={meta?.title}
          name='twitter:title'
        />
        <title>{meta?.title}</title>
      </>
    ) : null}

    {meta?.schema ? (
      <script
        dangerouslySetInnerHTML={{
          __html: sanitize(
            meta.schema
              .split('https://tophap.wpengine.com/')
              .join('https://tophap.com/')
          ) as string
        }}
        key='yoastSchema'
        className='yoast-schema-graph'
        type='application/ld+json'
      />
    ) : null}
  </Head>
)

export default Meta
